import Vue from 'vue';
import moment from 'moment'

const store = Vue.observable({
  chargerReport: {
      loaded: false,
      data: {
          cases: []
      }
  }
});

const actions = {
  async getChargerReport( period, xlsx=false ) {
      let result;
      if ( !period ) period = moment().format('YYYY-MM')

      let api = 'fleet/chargerReport';

      let url = `${api}?period=${period}${xlsx? '&format=xlsx': ''}`;

      if ( xlsx ) {
        return window.open( 'api/' + url);
      }

      store.chargerReport.loaded = false;
      try {
        result = await Vue.axios.get( url, { timeout: 60000 } );
      }
      catch (err) {
        result = err;
      }
      
      if (!result && result.error) return;
      store.chargerReport.data = result;
      store.chargerReport.loaded = true;
  }

}

export default {
    store,
    actions
}